/* eslint-disable max-len */
import 'react';

const ImportErrorSvg2 = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 20 20" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
                d="M10 3a7 7 0 110 14 7 7 0 010-14zm.088 9.457h-.175a.788.788 0 000 1.575h.175a.787.787 0 100-1.575zM10 6.157a.875.875 0 00-.875.875v3.763a.875.875 0 101.75 0V7.032A.875.875 0 0010 6.157z"
                fill="#FF7272"
            />
        </g>
    </svg>
);

export default ImportErrorSvg2;
